import { TransportAuthorization } from "../../../../../passapp-sdk/types/transportTypes";
import type { GuardiaRow } from "../GuardiaTable";

/**
 * Helpers de datos del ingreso. Viven acá y no en GuardiaTable para que los utils que agrupan
 * filas no tengan que importar el componente —y con él todo el árbol de React y los iconos—
 * sólo para leer la autorización de acceso.
 */

/** Autorización de transporte con la que la persona ingresó (dock, acoplado, etc.). */
export const getEntryTransportAuthorization = (
  row?: GuardiaRow
): TransportAuthorization | undefined =>
  row?.event?.transportAuthorizations?.find((auth) => auth.eventType === "in");

/**
 * Dock asignado al ingreso: sale de la autorización de transporte de entrada del evento.
 *
 * El acompañante de un transportista no tiene autorización propia —entra confirmado en guardia por
 * el mismo anfitrión que el chofer (ver `resolveTransportConfirmationSource` en useEvent.ts)—, así
 * que su evento no trae `transportAuthorizations`. El dock que heredó del chofer viaja en cambio en
 * esa misma confirmación, que el backend devuelve como `event.invites[0]`.
 */
export const getEntryDock = (row: GuardiaRow): string | number | null | undefined =>
  getEntryTransportAuthorization(row)?.dock ?? row?.event?.invites?.[0]?.dock;
